export { default } from './es/icons/ErrorOutlined';